import { FormGroup } from "@angular/forms";

export function passwordMatchValidator(formGroup: FormGroup) {
  const passwordControl = formGroup.get("password");
  const confirmPasswordControl = formGroup.get("confirmPassword");

  const password = passwordControl?.value;
  const confirmPassword = confirmPasswordControl?.value;

  // Verificar si las contraseñas coinciden
  if (password !== confirmPassword) {
    // Establecer un error en el control 'confirmPassword'
    confirmPasswordControl?.setErrors({ passwordMismatch: true });
  } else {
    // Limpiar el error si las contraseñas coinciden
    if (confirmPasswordControl?.hasError("passwordMismatch")) {
      confirmPasswordControl?.setErrors(null);
    }
  }
}
